import React, { useState, useEffect } from "react";
import { Box, Button, Typography, CircularProgress, useTheme, useMediaQuery } from "@mui/material";
import { startDailySession, endDailySession, checkActiveDailySession } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";

const DailySessions = () => {
  // ✅ جميع الـ Hooks يجب أن تكون في الأعلى قبل أي return مشروط
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDark = theme.palette.mode === "dark";

  const [loading, setLoading] = useState(false);
  const [sessionActive, setSessionActive] = useState(false);

  useEffect(() => {
    const fetchSessionStatus = async () => {
      setLoading(true);
      try {
        const status = await checkActiveDailySession();
        setSessionActive(status === "active");
      } catch (error) {
        console.error("❌ فشل في جلب حالة اليومية:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSessionStatus();
  }, []);

  // ✅ الآن نتحقق من isMobile بعد جميع الـ Hooks
  if (!isMobile) {
    return null;
  }

  const handleStartSession = async () => {
    setLoading(true);
    try {
      await startDailySession();
      alert("تم تفعيل اليومية بنجاح.");
      setSessionActive(true);
    } catch (error) {
      alert("فشل في تفعيل اليومية.");
    } finally {
      setLoading(false);
    }
  };

  const handleEndSession = async () => {
    setLoading(true);
    try {
      await endDailySession();
      alert("تم إيقاف اليومية بنجاح.");
      setSessionActive(false);

      // انتظار 5 ثواني ثم إعادة التشغيل تلقائياً
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // محاولة إعادة التفعيل بعد الانتظار
      try {
        await startDailySession();
        alert("تم بدا يومية جديدة بنجاح.");
        setSessionActive(true);
      } catch (startErr) {
        console.error("❌ فشل في إعادة تفعيل اليومية بعد الإيقاف:", startErr);
        alert("فشل في إعادة تفعيل اليومية بعد الإيقاف.");
      }
    } catch (error) {
      alert("فشل في إيقاف اليومية.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
      sx={{
        p: 3,
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: isDark ? "#1c1c2b" : "#f5f5f5",
        color: isDark ? "#fff" : "#232334",
      }}
    >
      <Typography variant="h6" fontWeight={700} sx={{ color: isDark ? "#f48fb1" : "#1976d2" }}>
        إدارة اليومية
      </Typography>
      {loading ? (
        <CircularProgress color="inherit" />
      ) : sessionActive ? (
        <Button
          variant="contained"
          color="error"
          onClick={handleEndSession}
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            px: 4,
            bgcolor: isDark ? "#d32f2f" : "#f44336",
            "&:hover": { bgcolor: isDark ? "#b71c1c" : "#e53935" },
          }}
        >
          إيقاف اليومية
        </Button>
      ) : (
        <Button
          variant="contained"
          color="success"
          onClick={handleStartSession}
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            px: 4,
            bgcolor: isDark ? "#388e3c" : "#4caf50",
            "&:hover": { bgcolor: isDark ? "#2e7d32" : "#43a047" },
          }}
        >
          تفعيل اليومية
        </Button>
      )}
    </Box>
  );
};

export default DailySessions;

